import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as dataSources from "./dataSourcesAll.actions";
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {map} from "rxjs/operators";
import {DataSourcesService} from "../../services/data-sources.service";
import {Serializer, Serializers} from '../../interfaces/serializer';
import {Site} from '../../interfaces/site';
import {Store} from '@ngrx/store';
import {AppState} from '../store';
import {selectSite} from '../init/init.selectors';
import {TypedAction} from '@ngrx/store/src/models';
import {DataSource} from '../../interfaces/data-source';

@Injectable()
export class DataSourcesAllEffects {
  private readonly _dataset$: Observable<Serializer<Site>> = this._store.select(selectSite);

  public load$ = createEffect((): Observable<TypedAction<any> & { dataSources: Serializers<DataSource> }> => this._actions$
    .pipe(
      ofType(dataSources.loadDataSourcesAll),
      withLatestFrom(this._dataset$),
      switchMap(([_, dataset]: [TypedAction<string>, Serializer<Site>]): Observable<Serializers<DataSource>> => this._dataSourcesS.getDataSources(dataset)),
      map((basicDataSources: Serializers<DataSource>): TypedAction<string> & { dataSources: Serializers<DataSource> } => dataSources.loadDataSourcesAllSuccess({
        dataSources: basicDataSources
      }))
    )
  );

  constructor(
    private readonly _actions$: Actions,
    private readonly _dataSourcesS: DataSourcesService,
    private readonly _store: Store<AppState>
  ) {}

}
